<template>
  <McTable
    :isHideMenu="false"
    :isHideAdd="false"
    :isHideSettings="false"
    :isLoading="isFetching"
    :search="search"
    :tabs="tabs"
    :headers="headers"
    :items="items"
    :footerProps="footerProps"
    :paging="paging"
    :pagingOptions="pagingOptions"
    :itemAction="true"
    :showExpand="true"
    :statusBorder="true"
  />
</template>

<script>
// @ is an alias to /src

// Utilities
import {
  // cloneDeep,
  // get
} from 'lodash'

import {
  mapState,
  // mapActions,
  // mapMutations
} from 'vuex'
import {
  UPDATE_STORE_AISLE_STATE,
  REQUEST_STORE_AISLE_LIST
} from '@/store/modules/aisleGuide'
import { initComponent } from '@/lib'


export default initComponent ('Users', {
  isPage: true,
  components : {
    // Chart1: () => import('./components/widgets/ChartOne'),
    McTable: () => import('@/components/base/Table'),
  },
    computed: {
    ...mapState({
      isFetching: (state) => state.aisleGuide.isFetching,
      isProcessing: (state) => state.aisleGuide.isProcessing,
      items: (state) => state.aisleGuide.items,
      paging: (state) => state.aisleGuide.paging,
      item: (state) => state.aisleGuide.item,
      search: (state) => state.aisleGuide.search,
      tabs: (state) => state.aisleGuide.tabs,
    }),
    pagingOptions() {
      let option = {
        state: 'aisleGuide',
        commit: UPDATE_STORE_AISLE_STATE,
        dispatch: REQUEST_STORE_AISLE_LIST,
      }
      return option;
    }
  },
  data: () => ({
    headers: [
      {
        text: '',
        align: 'center',
        sortable: false,
        value: 'status'
      },
      {
        text: 'Aisle Number',
        align: 'start',
        sortable: false,
        width: '20%',
        value: 'name',
      },
      {
        text: '',
        align: 'center',
        sortable: false,
        value: 'data-table-expand',
        width: 30,
      },
      {
        text: 'Title',
        align: 'center',
        sortable: false,
        value: 'title',
        width: '20%',
      },
      { 
        text: '',
        align: 'right',
        sortable: false,
        value: 'actions',
        width: '60%',
      },
    ],
  }),
  methods: {
    async onReady () {
      const { dispatch } = this.$store
      dispatch(REQUEST_STORE_AISLE_LIST);
    },
  }
})
</script>

<style lang="sass" scoped>

</style>